"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Common = require("../../../components/Common");
var _BillingForm = _interopRequireDefault(require("../../../components/Form/BillingForm"));
var _SquareCardForm = _interopRequireDefault(require("./SquareCardForm"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SquarePayment = function SquarePayment(_ref) {
  var appId = _ref.appId,
    baseUrl = _ref.baseUrl,
    locationId = _ref.locationId,
    onBack = _ref.onBack;
  var _useIntl = (0, _reactIntl.useIntl)(),
    locale = _useIntl.locale;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    billingContact = _useState2[0],
    setBillingContact = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    paymentsSdk = _useState4[0],
    setPaymentsSdk = _useState4[1];
  (0, _react.useEffect)(function () {
    var sqPaymentScript = document.createElement('script');
    sqPaymentScript.src = "https://".concat(baseUrl, "/v1/square.js"), sqPaymentScript.type = 'text/javascript', sqPaymentScript.async = false, sqPaymentScript.onload = function () {
      var payments = window.Square.payments(appId, locationId);
      payments.setLocale(locale), setPaymentsSdk(payments);
    }, document.getElementsByTagName('head')[0].appendChild(sqPaymentScript);
  }, []);
  var handleBillingAddressSubmit = function handleBillingAddressSubmit(values) {
    var addressLines = [values.address1];
    values.address2 && addressLines.push(values.address2), setBillingContact({
      addressLines: addressLines,
      city: values.city,
      countryCode: values.country,
      email: values.email,
      familyName: values.lastName,
      givenName: values.firstName,
      phone: values.phone,
      postalCode: values.postalCode,
      state: values.state
    });
  };
  return billingContact === null ? _react["default"].createElement(_BillingForm["default"], {
    displayErrorSummary: true,
    hideErrorLabels: true,
    hideLabels: true,
    provider: "square",
    requireAddress2: true,
    requirePostalCode: true,
    titleId: "htmPayment.square.service.billingAddress.title",
    onBack: onBack,
    onSubmit: handleBillingAddressSubmit
  }) : paymentsSdk === null ? _react["default"].createElement(_Common.Loader, {
    visible: true
  }) : _react["default"].createElement(_SquareCardForm["default"], {
    billingContact: billingContact,
    paymentsSdk: paymentsSdk,
    onBack: onBack
  });
};
var _default = exports["default"] = SquarePayment;